import { useState } from "react";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import { useCollection } from "react-firebase-hooks/firestore";
import { Loader } from "../hooks/useLoading";
import { Timestamp } from "firebase/firestore";
import { announcementsQuery } from "../utils/queryHelpers";
import AddAnnouncements from "../components/addAnnouncement";
import { useNavigate } from "react-router";
import no_image from "../assets/no_image.jpg";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../config/firebase"; 

const deleteAnnouncement = async (id) => {
  const confirmDelete = window.confirm("Are you sure you want to delete this announcement?");
  if (!confirmDelete) return;

  try {
    await updateDoc(doc(db, "announcements", id), {
      deleted: true,
      expired: true,
    });
    alert("Announcement deleted successfully!");
  } catch (err) {
    console.error("Error deleting announcement:", err);
    alert("Failed to delete announcement. Please try again.");
  }
};




const Announcements = () => {
  const [showEditModal, setShowEditModal] = useState(false);
  const [selected, setSelected] = useState(null);
  const [status, setstatus] = useState("Active");
  const navigate = useNavigate();
  const date = new Date();
  const todayTimestamp = Timestamp.fromDate(
    new Date(date.getFullYear(), date.getMonth(), date.getDate())
  );
  const [dialogType, setDialogType] = useState("Add");
  const [time, setTime] = useState(todayTimestamp);
  const [snapshot, loading, error] = useCollection(
    announcementsQuery({ status, time, deleted: false }),
    {
      snapshotListenOptions: {
        includeMetadataChanges: true,
      },
    }
  );

  return (
    <>
      <header className="d-flex   justify-content-between mb-3">
        <h4>Announcements</h4>
        <div className="d-flex gap-2">
          <select
            className="form-control"
            value={status}
            onChange={(e) => {
              setstatus(e.target.value);
              setTime(todayTimestamp);
            }}
          >
            <option value="Active">Active</option>
            <option value="Expired">Expired</option>
          </select>
          <Button
            variant="dark"
            onClick={() => {
              setDialogType("Add");
              setShowEditModal(true);
            }}
          >
            Add
          </Button>
        </div>
      </header>
      <main className="d-flex gap-1 flex-wrap">
        {loading && <Loader />}
        {error ? (
          <p className="text-error">
            There is some error. Please try again later
          </p>
        ) : null}
        {snapshot?.docs.length < 1 ? (
          <p className="text-center flex-fill"> No Data Available</p>
        ) : null}
        {snapshot?.docs.map((data) => {
          const d = { ...data.data(), id: data.id };
          // console.log({ d });
          return (
            <Card style={{ width: "18rem" }} key={d.id}>
              <Card.Img
                variant="top"
                src={d.image_url || no_image}
                style={{
                  width: "100%",
                  height: "200px",
                  objectFit: "contain",
                }}
                className="bg-dark"
              />
              <Card.Body>
                <Card.Title>{d.title}</Card.Title>
                <Card.Text>{d.link}</Card.Text>
              </Card.Body>
              <Card.Footer className="d-flex justify-content-between">
                <Button
                  variant="success"
                  style={{ width: "100%", height: "70px", padding: "10px",margin: "0px 5px" }}
                  onClick={() => {
                    navigate(`/dashboard/announcements/${d.id}`, {
                      state: d,
                    });
                  }}
                >
                  Add Users and Send
                </Button>
                <Button
                  variant="primary"
                  style={{ width: "50%", height: "50px", padding: "10px",margin: "0px 5px" }}
                  onClick={() => {
                    setSelected(d);
                    setShowEditModal(true);
                    setDialogType("Edit");
                  }}
                >
                  Edit
                </Button>
                <Button
                    variant="danger"
                    style={{ width: "50%", height: "50px", padding: "10px",margin: "0px 5px" }}
                    onClick={() => deleteAnnouncement(d.id)}
                  >
                    Delete
                  </Button>
              </Card.Footer>
            </Card>
          );
        })}
      </main>
      {showEditModal ? (
        <AddAnnouncements
          selected={selected}
          onClose={() => {
            setSelected(null);
            setShowEditModal(false);
          }}
          dialogType={dialogType}
        />
      ) : null}
    </>
  );
};

export default Announcements;
